import { useEffect, useState } from "react";
import { budgetStatus } from "./api";

/**
 * Currency symbol lookup used across the app.
 * Falls back to the ISO code + space when there's no dedicated glyph
 * (e.g. INR displays as "₹", but ZAR displays as "ZAR ").
 */
const SYMBOLS = {
  USD: "$",
  AUD: "A$",
  CAD: "C$",
  NZD: "NZ$",
  SGD: "S$",
  HKD: "HK$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CNY: "¥",
  INR: "₹",
  BRL: "R$",
  MXN: "Mex$",
  CHF: "CHF ",
  SEK: "kr ",
  NOK: "kr ",
  DKK: "kr ",
  ZAR: "R ",
  AED: "د.إ ",
  KRW: "₩",
};

export function currencySymbol(code) {
  return SYMBOLS[(code || "USD").toUpperCase()] || `${(code || "USD").toUpperCase()} `;
}

/** Formats an amount with the correct symbol for the display currency. */
export function formatMoney(amount, code = "USD", fractionDigits = 2) {
  const n = Number.isFinite(amount) ? amount : 0;
  return `${currencySymbol(code)}${n.toFixed(fractionDigits)}`;
}

/**
 * Fetches the workspace's configured display currency from the budget doc.
 * Cached in-module for the lifetime of the tab so repeated dialog opens
 * don't hammer the API. Falls back to "USD" on any error.
 */
let _cachedCurrency = null;
export function useDisplayCurrency(active = true) {
  const [currency, setCurrency] = useState(_cachedCurrency || "USD");
  useEffect(() => {
    if (!active || _cachedCurrency) return;
    let cancelled = false;
    budgetStatus()
      .then((data) => {
        const ccy = (data?.display_currency || "USD").toUpperCase();
        _cachedCurrency = ccy;
        if (!cancelled) setCurrency(ccy);
      })
      .catch(() => {
        /* keep USD fallback */
      });
    return () => {
      cancelled = true;
    };
  }, [active]);
  return currency;
}
